import { Action } from 'modules/store'

import { ToastPayload } from '../../shared'

export const ADD_TOAST = '[toasterer] Add toast'
export const REMOVE_TOAST = '[toasterer] Remove toast'

export class AddToastAction implements Action {
  readonly type = ADD_TOAST
  constructor(public payload: ToastPayload) {}
}

export class RemoveToastAction implements Action {
  readonly type = REMOVE_TOAST
  constructor(public payload: string) {}
}

export class DummyToastAction implements Action {
  readonly type = 'dummy toast action type'
}

export type ToastererActions = AddToastAction | RemoveToastAction | DummyToastAction

export default ToastererActions



// WEBPACK FOOTER //
// ./src/app/shared/store/toasterer.actions.ts